
import { PaymentMethod } from './typing';
import {isWechat, isMobile, isPC} from "@firefly/fly-defter";

// export const NEED_CONFIRM_PAYMENT_SESSION_STORAGE_KEY = 'needConfirmPayment';

export enum PaymentMethods {
  ALIPAY_PRECREATE = 'ALIPAY:PRECREATE',
  ALIPAY_PAGE = 'ALIPAY:PAGE',
  ALIPAY_WAP = 'ALIPAY:WAP',
  WECHATPAY_JSAPI = 'WECHATPAY:JSAPI',
  WECHATPAY_NATIVE = 'WECHATPAY:NATIVE',
  WECHATPAY_H5 = 'WECHATPAY:H5',
}

export const DEFAULT_METHODS: PaymentMethod[] = Object.values(
  PaymentMethods,
) as any;

export const PAYMENT_METHOD_OPTIONS: {
  [key: string]: {
    enabled: boolean;
  };
} = {
  [PaymentMethods.WECHATPAY_JSAPI]: {
    enabled: isWechat(),
  },
  [PaymentMethods.WECHATPAY_H5]: {
    enabled: !isWechat() && isMobile(),
  },
  [PaymentMethods.WECHATPAY_NATIVE]: {
    enabled: !isWechat() && !isMobile(),
  },
  [PaymentMethods.ALIPAY_PAGE]: {
    enabled: !isWechat() && isPC(),
  },
  [PaymentMethods.ALIPAY_WAP]: {
    enabled:
      isMobile() &&
      !isWechat(),
      // !isMiniapp()
  },
};
